var map = {
	"./cake.webp": 2382,
	"./correct-ico.webp": 2383,
	"./crown-blue.webp": 2384,
	"./crown.webp": 2385,
	"./pocket.webp": 2386,
	"./present.webp": 2387,
	"./relegation.webp": 2388,
	"./t-deposit.webp": 2389,
	"./t-turnover.webp": 2390,
	"./vip-1.webp": 2391,
	"./vip-2.webp": 2392,
	"./vip-3.webp": 2393,
	"./vip-4.webp": 2394,
	"./vip-5.webp": 2395,
	"./vip-badge.webp": 2396,
	"./vip-bg.webp": 2397,
	"./vip-bonus-bg.webp": 2398,
	"./vip1.webp": 2399,
	"./vip2.webp": 2400,
	"./vip3.webp": 2401,
	"./vip4.webp": 2402,
	"./vip5.webp": 2403,
	"./vip6.webp": 2404
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 396;